module.exports = __webpack_public_path__ + "static/img/new_game_1.00ea121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/new_game_1.png
// module id = y1AD
// module chunks = 1